<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="dedication"><a id="page_7"><i>For Lizzie, Alan and Sally. I am justifiably proud of them</i>.</a></p><a id="page_7">
</a></div><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Dedication.vue?6a0c4714